var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2191",
    "data-name": "Group 2191",
    transform: "translate(-530 -627)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_326",
    "data-name": "Ellipse 326",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(530 627)",
    fill: "#3478ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2-Email",
    "data-name": "2-Email",
    transform: "translate(548.164 648.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42811",
    "data-name": "Path 42811",
    d: "M22.5,4H2.327A2.327,2.327,0,0,0,0,6.327V20.291a2.327,2.327,0,0,0,2.327,2.327H22.5a2.327,2.327,0,0,0,2.327-2.327V6.327A2.327,2.327,0,0,0,22.5,4ZM21.94,5.552l-9.527,6.8-9.527-6.8ZM1.552,19.973V6.506L9.4,12.114Zm1.094,1.094,8.037-8.037,1.272.908a.776.776,0,0,0,.9,0l1.272-.908,8.053,8.037Zm20.628-1.094-7.851-7.858,7.851-5.609Z",
    transform: "translate(0 -4)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.07e699633e0d6ec4bec5986a04d0f03a.svg";
export { ForwardRef as ReactComponent };